import { FC, ReactNode } from "react"
import classNames from "classnames"
import { Icon, IconColor, IconProps } from "../shared/Icon"
import { TestId } from "@/constants/globals"

interface TextFieldProps {
   name?: string
   children?: ReactNode
   onClick?: () => void
}

const TextField: FC<TextFieldProps> = ({ name, children, onClick }) => {
   const iconMapping: Record<string, IconProps["name"]> = {
      name: "facility",
      state: "flag",
      city: "city",
      street: "street",
      zipCode: "mail",
      timezone: "timezone",
      cells: "cell",
      wearables: "smartwatch",
      users: "guardUser",
   }

   return (
      <>
         {name && iconMapping[name] && (
            <Icon
               name={iconMapping[name]}
               size="16px"
               color={IconColor.HONOLULU_BLUE}
            />
         )}
         <span
            className={classNames({
               "customers-facilities-table__text-field--clickable": onClick,
            })}
            data-testid={TestId.CUSTOMER_FACILITIES_TABLE_TEXT_FIELD}
            {...(onClick && {
               onClick: (e) => {
                  e.preventDefault()
                  onClick()
               },
            })}
         >
            {children == null ||
            (typeof children === "number" && isNaN(children))
               ? "-"
               : children}
         </span>
      </>
   )
}

export default TextField
